import styled from 'styled-components';

import { FontWeight, Color } from '../../theme';

const BaseHeaderStyle = `
  color: ${Color.darkGrey};
  font-size: 60px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0.2px;
  line-height: 52px;
`;

export const HeaderH1 = styled.h1`
  ${BaseHeaderStyle}
  font-size: 60px;
  line-height: 52px;
`;

export const HeaderH2 = styled.h2`
  ${BaseHeaderStyle}
  font-size: 50px;
  line-height: 65px;
`;

export const HeaderH3 = styled.h3`
  ${BaseHeaderStyle}
  font-size: 45px;
  line-height: 58px;
`;

export const HeaderH4 = styled.h4`
  ${BaseHeaderStyle}
  font-size: 35px;
  line-height: 46px;
`;

export const HeaderH5 = styled.h5`
  ${BaseHeaderStyle}
  font-size: 25px;
  line-height: 28px;
`;
